import { Alignment, Autoformat, Bold, ClassicEditor, Essentials, Font, Heading, HorizontalLine, Image, ImageCaption, ImageResize, ImageStyle, ImageToolbar, ImageUpload, Indent, Italic, Link, LinkImage, List, MediaEmbed, Paragraph, PasteFromOffice, RemoveFormat, SimpleUploadAdapter, SourceEditing, Strikethrough, TextTransformation, Underline, type EditorConfig } from 'ckeditor5';

// @ts-ignore
import coreTranslations from 'ckeditor5/translations/de.js';

import 'ckeditor5/ckeditor5.css';
import './styles.css';

class Editor extends ClassicEditor {}
class EmailEditor extends ClassicEditor {}
class SimpleEditor extends ClassicEditor {}

// Full editor.
Editor.builtinPlugins = [
	Autoformat,
	Bold,
	Essentials,
	Heading,
	Indent,
	Italic,
	Underline,
	Strikethrough,
	Link,
	List,
	Paragraph,
	Font,
	TextTransformation,
	SourceEditing,
	SimpleUploadAdapter,
	Image,
	ImageUpload,
	ImageToolbar,
	ImageCaption,
	ImageStyle,
	ImageResize,
	LinkImage,
	HorizontalLine,
	RemoveFormat,
	PasteFromOffice,
	Alignment,
	MediaEmbed,
];

Editor.defaultConfig = {
	licenseKey: 'GPL',
	toolbar: {
		items: [
			'undo', 'redo',
			'|',
			'heading',
			'|',
			'fontSize', 'fontColor', 'fontBackgroundColor',
			'|',
			'bold', 'italic', 'underline', 'strikethrough',
			'|',
			'alignment',
			'|',
			'removeFormat',
			'-',
			'link',
			'imageUpload',
			'mediaEmbed',
			'|',
			'horizontalLine',
			'|',
			'bulletedList', 'numberedList',
			'outdent', 'indent',
			'|',
			'sourceEditing',
		],
		shouldNotGroupWhenFull: true
	},
	alignment: {
		options: [ 'left', 'center', 'right' ]
	},
	link: {
		decorators: {
			openInNewTab: {
				mode: 'manual',
				label: 'Open in a new tab',
				attributes: {
					target: '_blank',
				},
			},
		},
		toolbar: [ 'linkPreview', '|', 'editLink', 'linkProperties', 'unlink' ]
	},
	image: {
		toolbar: [
			'imageStyle:alignLeft',
			'imageStyle:block',
			'imageStyle:alignRight',
			'|',
			'toggleImageCaption',
			'imageTextAlternative',
			'|',
			'linkImage'
		]
	},
	language: 'de',
	simpleUpload: {
		uploadUrl: '/admin/assets/framework/script/ckeditor-upload.php',
		withCredentials: true,
	},
	fontSize: {
		options: [
			'small',
			'default',
			'big',
			'huge',
		],
	},
	fontColor: {
		colors: [
			{
				color: '#191919',
				label: 'Schwarz'
			},
			{
				color: '#454545',
				label: 'Grau'
			},
			{
				color: '#ffffff',
				label: 'Weiss',
				hasBorder: true
			},
			{
				color: '#c00',
				label: 'Rot',
			},
			{
				color: '#cc6600',
				label: 'Orange',
			},
			{
				color: '#e2db04',
				label: 'Gelb',
			},
			{
				color: '#53Bc5c',
				label: 'Green',
			},
		],
		colorPicker: false,
	},
	fontBackgroundColor: {
		colors: [
			{
				color: '#191919',
				label: 'Schwarz'
			},
			{
				color: '#454545',
				label: 'Grau'
			},
			{
				color: '#ffffff',
				label: 'Weiss',
				hasBorder: true
			},
			{
				color: '#c00',
				label: 'Rot',
			},
			{
				color: '#cc6600',
				label: 'Orange',
			},
			{
				color: '#e2db04',
				label: 'Gelb',
			},
			{
				color: '#53Bc5c',
				label: 'Green',
			},
		],
		colorPicker: false
	},
	typing: {
		transformations: {
			include: [
				'symbols',
				'mathematical',
				'typography',
				{ from: '>>', to: '»' },
				{ from: '<<', to: '«' },
			]
		}
	},
	mediaEmbed: {
		previewsInData: true,
		providers: [
			/**
			 * Note this is an override for the Spotify provider.
			 *
			 * @see https://ckeditor.com/docs/ckeditor5/latest/features/media-embed.html#overriding-media-providers
			 */
			{
				name: 'spotify',
				url: [
					/^open\.spotify\.com\/(artist\/\w+)/,
					/^open\.spotify\.com\/(album\/\w+)/,
					/^open\.spotify\.com\/(track\/\w+)/,
					// Add: Episode and show links - these are not yet supported by CKEditor.
					/^open\.spotify\.com\/(episode\/\w+)/,
					/^open\.spotify\.com\/(show\/\w+)/,
				],
				html: match => {
					const id = match[ 1 ];

					return (
						'<div style="position: relative;">' +
							`<iframe src="https://open.spotify.com/embed/${ id }" ` +
								'style="width: 100%; height: 100%; top: 0; left: 0;" ' +
								'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
							'</iframe>' +
						'</div>'
					);
				}
			},
		]
	},
	translations: [
			coreTranslations,
	],
};

// Email editor.
EmailEditor.builtinPlugins = [
	Autoformat,
	Bold,
	Essentials,
	Heading,
	Indent,
	Italic,
	Underline,
	Strikethrough,
	Link,
	List,
	Paragraph,
	Font,
	TextTransformation,
	SourceEditing,
	SimpleUploadAdapter,
	Image,
	ImageUpload,
	ImageToolbar,
	ImageCaption,
	ImageStyle,
	ImageResize,
	LinkImage,
	HorizontalLine,
	RemoveFormat,
	PasteFromOffice,
	Alignment,
];

EmailEditor.defaultConfig = {
	licenseKey: 'GPL',
	toolbar: {
		items: [
			'undo', 'redo',
			'|',
			'heading',
			'|',
			'fontSize', 'fontColor', 'fontBackgroundColor',
			'|',
			'bold', 'italic', 'underline', 'strikethrough',
			'|',
			'alignment',
			'|',
			'removeFormat',
			'-',
			'link',
			'imageUpload',
			'|',
			'horizontalLine',
			'|',
			'bulletedList', 'numberedList',
			'outdent', 'indent',
			'|',
			'sourceEditing',
		],
		shouldNotGroupWhenFull: true
	},
	alignment: {
		options: [ 'left', 'center', 'right' ]
	},
	image: {
		styles: {
			// Defining custom styling options for the images.
			options: [
				'alignLeft',
				'block',
				'alignRight',
				{
					name: 'noMargins',
					icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="currentColor" d="M15.003 11v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1Zm-1.506.5H6.5V16h6.997v-4.5Z"/><path fill="currentColor" d="M15.003 4v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1Zm-1.506.5H6.5V9h6.997V4.5Z"/></svg>`,
					title: 'Keine Abstände',
					className: 'no-margins',
					modelElements: [ 'imageBlock' ]
				}
			],
		},
		toolbar: [
			'imageStyle:alignLeft',
			'imageStyle:block',
			'imageStyle:alignRight',
			'imageStyle:noMargins',
			'|',
			'toggleImageCaption',
			'imageTextAlternative',
			'|',
			'linkImage',
		]
	},
	language: 'de',
	simpleUpload: {
		uploadUrl: '/admin/assets/framework/script/ckeditor-upload.php',
		withCredentials: true,
	},
	fontSize: {
		options: [
			{
				title: 'Klein',
				model: '0.85em',
			},
			'default',
			{
				title: 'Gross',
				model: '1.2em',
			},
			{
				title: 'Riesig',
				model: '1.4em',
			},
		],
	},
	fontColor: {
		colors: [
			{
				color: '#191919',
				label: 'Schwarz'
			},
			{
				color: '#454545',
				label: 'Grau'
			},
			{
				color: '#ffffff',
				label: 'Weiss',
				hasBorder: true
			},
			{
				color: '#c00',
				label: 'Rot',
			},
			{
				color: '#cc6600',
				label: 'Orange',
			},
			{
				color: '#e2db04',
				label: 'Gelb',
			},
			{
				color: '#53Bc5c',
				label: 'Green',
			},
		],
		colorPicker: false,
	},
	fontBackgroundColor: {
		colors: [
			{
				color: '#191919',
				label: 'Schwarz'
			},
			{
				color: '#454545',
				label: 'Grau'
			},
			{
				color: '#ffffff',
				label: 'Weiss',
				hasBorder: true
			},
			{
				color: '#c00',
				label: 'Rot',
			},
			{
				color: '#cc6600',
				label: 'Orange',
			},
			{
				color: '#e2db04',
				label: 'Gelb',
			},
			{
				color: '#53Bc5c',
				label: 'Green',
			},
		],
		colorPicker: false
	},
	typing: {
		transformations: {
			include: [
				'symbols',
				'mathematical',
				'typography',
				{ from: '>>', to: '»' },
				{ from: '<<', to: '«' },
			]
		}
	},
	translations: [
			coreTranslations,
	],
};

// Simple editor.
SimpleEditor.builtinPlugins = [
	Autoformat,
	Bold,
	Essentials,
	Italic,
	Underline,
	Strikethrough,
	Link,
	Paragraph,
	TextTransformation,
	SourceEditing,
	RemoveFormat,
];

SimpleEditor.defaultConfig = {
	licenseKey: 'GPL',
	toolbar: {
		items: [
			'undo', 'redo',
			'|',
			'bold', 'italic', 'underline', 'strikethrough',
			'|',
			'link',
			'|',
			'removeFormat',
			'|',
			'sourceEditing',
		],
	},
	link: {
		decorators: {
			openInNewTab: {
				mode: 'manual',
				label: 'Open in a new tab',
				attributes: {
					target: '_blank',
				},
			},
		},
		toolbar: [ 'linkPreview', '|', 'editLink', 'linkProperties', 'unlink' ]
	},
	language: 'de',
	typing: {
		transformations: {
			include: [
				'symbols',
				'mathematical',
				'typography',
				{ from: '>>', to: '»' },
				{ from: '<<', to: '«' },
			]
		}
	},
	translations: [
			coreTranslations,
	],
};

const activeEditors = new Map<string, ClassicEditor>();

const _createEditor = ( editor: typeof ClassicEditor, id: string, config?: EditorConfig ) => {
	const element = document.getElementById( id );
	if ( ! element ) {
		return;
	}

	var oldEditor = activeEditors.get( id );
	if ( oldEditor ) {
		oldEditor.destroy();
	}

	editor.create( element, config || {} )
		.then( editor => {
			activeEditors.set( id, editor );
		} )
		.catch( err => {
			console.error( err.stack );
		} );
}

const createEditor = ( id: string, config?: EditorConfig ) => {
	_createEditor( Editor, id, config );
}

const createEmailEditor = ( id: string, config?: EditorConfig ) => {
	_createEditor( EmailEditor, id, config );
}

const createSimpleEditor = ( id: string, config?: EditorConfig ) => {
	_createEditor( SimpleEditor, id, config );
}

export default { activeEditors, createEditor, createEmailEditor, createSimpleEditor };
